import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { UserRoles } from "../../types/user.types";
import CompetitionsInvitedUser from "./competitions-invited-user";
import { CompetitionsPrimaryUser } from "./competitions-primary-user";
import { CurrentCompetitionAdmins } from "./current-competition-admins";

export function CompetitionsRoleRouter() {
  const { user } = useAuth();

  return (
    <>
      {user?.roleId === UserRoles.PRIMARY_USER ? (
        <CompetitionsPrimaryUser />
      ) : user?.roleId === UserRoles.INVITED_USER ? (
        <CompetitionsInvitedUser />
      ) : user?.roleId === UserRoles.SYSTEM_ADMIN ||
        user?.roleId === UserRoles.CLIENT_ADMIN ? (
        <CurrentCompetitionAdmins />
      ) : (
        <Navigate to="/unauthorized" />
      )}
    </>
  );
}
